import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import vw from 'styles/utils';
import media from 'styles/media';

function Hamburger(props) {
  const { active, onClick } = props;

  return (
    <Root onClick={onClick} active={active}>
      <span />
      <span />
      <span />
    </Root>
  )
}

Hamburger.propTypes = {
  active: PropTypes.bool, 
  onClick: PropTypes.func
}

const Root = styled.div`
  display: block;
  z-index: 10;
  position: relative;

  ${vw('width', 25)}
  ${vw('height', 15)}

  @media ${media.tablet} {
    display: none;
  }

  > span {
    height: 2px;
    width: 100%;
    background: #0068B7;
    display: block;
    position: absolute;
    transition: all 0.25s;

    &:nth-of-type(1) {
      position: absolute;
      top: ${props => props.active ? '50%' : '0'};
      transform: ${props => props.active ? 'translateY(-50%) rotate(45deg)' : '0'};
    }
    &:nth-of-type(2) {
      top: 50%;
      transform: ${props => props.active && 'scaleX(0)'};
      opacity: ${props => props.active ? '0' : '1'};
    }
    &:nth-of-type(3) {
      top: ${props => props.active ? '50%' : '100%'};
      transform: ${props => props.active && 'translateY(-50%) rotate(-45deg)'};
    }
  }
`;

export default Hamburger
